var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0431 22.25H15.9569C19.1563 22.25 21.75 19.6563 21.75 16.4569V12.5V10.5216V8.75C21.75 5.43629 19.0637 2.75 15.75 2.75H13.9784H12H8.0431C4.84366 2.75 2.25 5.34366 2.25 8.5431V16.4569C2.25 19.6563 4.84366 22.25 8.0431 22.25Z",
    fill: "#500D76",
    stroke: "#500D76",
    strokeWidth: 1.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.138C15.75 14.2091 14.0711 15.888 12 15.888C9.92893 15.888 8.25 14.2091 8.25 12.138C8.25 10.0669 9.92893 8.38801 12 8.38801C14.0711 8.38801 15.75 10.0669 15.75 12.138Z",
    fill: "#500D76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2492 10.86L12.751 13.4161M15.75 12.138C15.75 14.2091 14.0711 15.888 12 15.888C9.92893 15.888 8.25 14.2091 8.25 12.138C8.25 10.0669 9.92893 8.38801 12 8.38801C14.0711 8.38801 15.75 10.0669 15.75 12.138Z",
    stroke: "#EDE3F3",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2492 10.86L12.751 13.4161",
    stroke: "#EDE3F3",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApOnline);
export default __webpack_public_path__ + "static/media/AP_online.c96d819899e035adf4541d5d96a8530c.svg";
export { ForwardRef as ReactComponent };